import { store } from '@/store/main';
import { clearPreviewTemplate, updateWorkingProjectWithIndexedDb } from '@/store/slices/project';

const chooseTemplateLoader = async () => {
  // clear template draft from store so clicking the same template again will reload it fresh
  // alternatively, if we want to "keep"  the work in progress, we could remove this, and inside
  // the create project from draft flow just add a "reset" button that resets indexeddb abd the store
  // to the original template
  store.dispatch(updateWorkingProjectWithIndexedDb(null));
  store.dispatch(clearPreviewTemplate());
};

export default chooseTemplateLoader;
